export const environment = {
  production: false,
  development: true,
  // Aquí pones la URL del servidor real
  apiUrl: 'https://backend-dev.holaserenia.com/api/chromadb'
};